<div class="bank_reconciliation_view container">
    <mat-tab-group [mat-stretch-tabs]="false">
        <mat-tab label="Task">
            <app-task></app-task>
        </mat-tab>
        <mat-tab label="Suspend Account">
            <app-suspend></app-suspend>
        </mat-tab>
        <mat-tab label="Advance">
            <app-advance></app-advance>
        </mat-tab>
        <mat-tab label="Unadjusted Amount">
            <app-unadjusted></app-unadjusted>
        </mat-tab>
    </mat-tab-group>
</div>